import { GenericMqttMessageContent } from '../generic-mqtt-message-content.model';
import { GetGeoTopoArea } from './get-geo-topo-area.model';

export class GetGeoTopoContent extends GenericMqttMessageContent {

    constructor(json: any = null) {
        super(json);

        if (json) {
            Object.assign(this, json);

            if (json.result) this.result = json.result.map(c => new GetGeoTopoArea(c));
        }
    }

    result: GetGeoTopoArea[];
}
